import { ButtonLink, CompUser, ContentFlex, CusAccordion, DetailsCourse, DetailsTitle, DiscPart, Image, ImageSection, ImageUser, LeftSection, LinkPart, PartDisc, RightSection, Section, TextDiscretion, TitleDisc, TitleInfo, UserImage, UserText, UserTextLight, VideoLink, VideoPart } from './StyledCourseDescription'
import * as images from './data/images';
import { Circle, user } from '../../../images';
import { AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useParams } from 'react-router-dom';
import { GET_REQUEST } from '../../../HooksApi/useApi';
import UseGetData from '../../../HookAxios/getdata';
import { useDispatch, useSelector } from 'react-redux';
import { Fade } from 'react-reveal';
import { useEffect } from 'react';
import * as partS from '../AboutCourse/redux/actions';
import { useModalContext } from '../../../Provider/ModalProvider';
import { Box } from '@mui/system';
import { useTheme } from '@emotion/react';
import Dots from './../../../Components/Loader/Dots';

const CourseDescription = () => {
    const AboutCourse = useSelector((state) => state.Courses.AboutCourse)
    const SectionsBy = useSelector((state) => state.Courses.SectionsByCourse.data)
    const token = useSelector((state) => state.Auth.userInfo.token)
    const { openLockedAccessDepartment } = useModalContext()
    const { openLockedAcsses } = useModalContext()
    const { id } = useParams()
    const theme = useTheme();
    const { isLoading: LoadPart, data: dataPart }
        = GET_REQUEST({
            queryKey: `CoursePart${id}`
            , request: () => UseGetData('get_sessions_by_section_id',
                { id: id }, { "Authorization": `Bearer ${token}` }), enabled: true
        })
    const dispatch = useDispatch()
    useEffect(() => {
        if (!LoadPart && dataPart?.data?.data?.videos) {
            dispatch(partS.GetSessionsByCourse(dataPart?.data?.data?.videos))
        }
    }, [LoadPart])
    return (
        <div style={{ height: '80vh' }}>
            <Section>
                <LeftSection>
                    <DetailsCourse>
                        <ImageSection>
                            <Image src={`${process.env.REACT_APP_BASE_URL}${AboutCourse?.data?.image_path}`} />
                        </ImageSection>
                        <DetailsTitle>
                            {AboutCourse?.data?.name}
                        </DetailsTitle>
                        <TextDiscretion>
                            {AboutCourse?.data?.teacher_name}
                            {/* <img src={Circle} style={{ margin: '5px 7px' }} alt="circle" /> */}
                            {AboutCourse?.data?.date_of_create ? `- ${AboutCourse?.data?.date_of_create}` : ''}
                        </TextDiscretion>
                    </DetailsCourse>
                    <ContentFlex>
                        <CusAccordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography> محتوى الدورة</Typography>
                            </AccordionSummary>
                            <AccordionDetails style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '10px' }} >
                                {
                                    SectionsBy ?
                                        SectionsBy.map((el) =>
                                            <LinkPart
                                                to={el.session_count !== 0 ? `/course-description/${el.id}` : ''}
                                                onClick={() => el.session_count === 0 ? openLockedAccessDepartment() : ""} key={el.id}
                                                style={({ isActive }) => ({
                                                    color: isActive && '#000',
                                                    background: isActive && '#F2F2F2'
                                                })}
                                            >
                                                {el.name}
                                            </LinkPart>) : "load"
                                }
                            </AccordionDetails>
                        </CusAccordion>
                    </ContentFlex>
                </LeftSection>
                <RightSection>
                    {
                        !LoadPart && dataPart ?
                            <Fade>
                                <PartDisc>
                                    <TitleDisc>  {dataPart?.data?.data?.section.name}</TitleDisc>

                                    <DiscPart>
                                        {/* {dataPart?.data?.data?.section.brief} */}
                                    </DiscPart>
                                    <VideoPart>
                                        {
                                            dataPart?.data?.data?.videos.map((data) =>
                                                data.is_public || (!data.is_public && data.is_subscribtion) ?
                                                    <VideoLink VideoLink key={data.id} style={{
                                                        // color: data.completed && " #828282"
                                                    }}
                                                        to={`/course-description/${id}/vedname/${data.id}`}>
                                                        <img src={images.vedio1} alt="" />
                                                        {data.title + " "}
                                                        <Box color={theme.palette.mode === "dark" ? "#ffffff" : "#333333"}>
                                                            ({data?.duration < 1 ? `${Math.ceil(data?.duration * 60)} ثانية` : data?.duration < 60 ? `${Math.ceil(data?.duration)} دقيقة` : `${Math.ceil(data?.duration / 60)} ساعة`})

                                                        </Box>
                                                        {/* // data.completed ? <img src={Completed} alt="" /> : <img src={Queze1} alt="" /> */}
                                                    </VideoLink> :
                                                    <ButtonLink onClick={openLockedAcsses} style={{ color: 'gray' }} >
                                                        <img src={images.Lock} alt="" />
                                                        {data.title + " "}
                                                        <Box color={theme.palette.mode === "dark" ? "#ffffff" : "#333333"}>
                                                            ({data?.duration < 1 ? `${data?.duration * 60} ثانية` : data?.duration < 60 ? `${Math.ceil(data?.duration)} دقيقة` : `${Math.ceil(data?.duration / 60)} ساعة`})

                                                        </Box>

                                                    </ButtonLink>
                                            )
                                        }
                                        {/* <VideoLink to={`/test-unit/${id}`}>
                                            <img src={images.Queze} alt="" />
                                            اختبار القسم
                                        </VideoLink> */}
                                    </VideoPart>
                                </PartDisc>
                            </Fade>
                            : <Dots />
                    }
                </RightSection>
            </Section >

        </div>
    )
}

export default CourseDescription